/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { useDispatch } from 'react-redux';

import TableSetting, { ITableSettingProps } from '../../../../components/TableSetting/TableSetting';
import { modalOpen } from '../../../modal/modalActions';
import { IModalRenderProps } from '../../../modal/types/modalTypes';
import { ITableMetaResponse } from '../../index';
import { useTableColumnSettings } from './useTableColumnSettings';

export const useTableSettingOpen = ({ locale }: Pick<ITableSettingProps<any>, 'locale'>) => {

    const dispatch = useDispatch();

    const {
        requiredFields,
        draggableFields,
        changeColumnOrder,
    } = useTableColumnSettings();

    const open = () => {
        dispatch(modalOpen({
            /* TODO: migrate to rtk */
            render: (props: IModalRenderProps) =>
                <TableSetting
                    fields={draggableFields}
                    isOpen={false}
                    locale={locale}
                    requiredFields={requiredFields}
                    onApply={(tableFields: ITableMetaResponse['fields']) => {
                        changeColumnOrder(tableFields);
                        props.onCloseModal();
                    }}
                    onClose={props.onCloseModal}
                />,
        }));
    };

    return { open };
};
